import { render, staticRenderFns } from "./BranchVerification.vue?vue&type=template&id=275e7608"
import script from "./BranchVerification.vue?vue&type=script&lang=js"
export * from "./BranchVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports